import { useState } from 'react';
import { getApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

export function resolveUserPhotoURL(user) {
  if (user?.photoURL) return user.photoURL;
  try {
    return getAuth(getApp()).currentUser?.photoURL || null;
  } catch {
    return null;
  }
}

function initials(name = '') {
  const p = String(name).trim().split(/\s+/).filter(Boolean);
  if (p.length > 1) return (p[0][0] + p[p.length - 1][0]).toUpperCase();
  return (p[0]?.[0] || '?').toUpperCase();
}

/** Profile image from Google / mail sign-in, with initials fallback. */
export default function UserAvatar({
  user,
  name,
  size = 28,
  accent = '#0e9cc0',
  borderRadius = 6,
  className,
  style,
}) {
  const displayName = name || user?.name || user?.email || '';
  const photoURL = resolveUserPhotoURL(user);
  const [failed, setFailed] = useState(false);

  const shell = {
    width: size,
    height: size,
    borderRadius,
    flexShrink: 0,
    overflow: 'hidden',
    display: 'grid',
    placeItems: 'center',
    background: `${accent}18`,
    border: `0.5px solid ${accent}44`,
    fontFamily: "'Share Tech Mono', monospace",
    fontSize: Math.max(9, size * 0.36),
    fontWeight: 700,
    color: accent,
    ...style,
  };

  if (photoURL && !failed) {
    return (
      <img
        className={className}
        src={photoURL}
        alt={displayName ? `${displayName} profile` : 'Profile'}
        referrerPolicy="no-referrer"
        onError={() => setFailed(true)}
        style={{ ...shell, objectFit: 'cover', padding: 0 }}
      />
    );
  }

  return (
    <div className={className} style={shell} aria-hidden={!displayName}>
      {initials(displayName)}
    </div>
  );
}
